import {
  Button,
  DomElementAlignment,
  DomTargetPosition,
  OdinIcon,
  OdinIconSize,
  OverlayPanel,
  TabView,
  TabViewPanel,
} from '@myosh/odin-components';
import { memo, useCallback, useRef, useState } from 'react';
import DisplayFilterTab, { type DisplayFilterTabRef } from './display-filter-tab.component';

function FilterOverlay() {
  const [isFilterOverlayOpen, setIsFilterOverlayOpen] = useState(false);

  const filterIconRef = useRef<HTMLDivElement>(null);
  const displayFilterTabRef = useRef<DisplayFilterTabRef>(null);

  const toggleFilterOverlay = useCallback(() => {
    setIsFilterOverlayOpen((isOpen) => !isOpen);
  }, []);

  const closeFilterOverlay = useCallback(() => {
    setIsFilterOverlayOpen(false);
  }, []);

  const handleSave = useCallback(() => {
    displayFilterTabRef.current?.save();
    closeFilterOverlay();
  }, []);

  return (
    <>
      <div
        data-cy="filter-toggle-button"
        className="bt-flex bt-items-center"
        ref={filterIconRef}
        onClick={toggleFilterOverlay}
      >
        <OdinIcon
          icon="Filter"
          size={OdinIconSize.Small}
          className="bt-cursor-pointer bt-rounded-md bt-text-primary-1 hover:bt-bg-primary-5"
        />
      </div>
      <OverlayPanel
        data-cy="filter-overlay-panel"
        target={filterIconRef.current}
        visible={isFilterOverlayOpen}
        hidden={closeFilterOverlay}
        elementAlignment={DomElementAlignment.TopLeft}
        targetPosition={DomTargetPosition.BottomLeft}
        mountOnEnter={true}
        shouldCheckZIndex={true}
        shouldUseCreatePortal={false}
        shouldRemainOnScreen={true}
        className="bt-w-96 bt-min-w-min bt-max-w-lg bt-bg-mono-1 bt-p-4"
      >
        <div className="bt-max-h-fit bt-min-h-64">
          <div
            data-cy="filter-overlay-close-button"
            className="bt-absolute bt-right-1 bt-top-1 bt-cursor-pointer"
            onClick={closeFilterOverlay}
          >
            <OdinIcon icon="X" />
          </div>
          <TabView
            headerClassName="bt-font-medium bt-text-base"
            className="bt-hover:text-primary-1 bt-mr-4 bt-cursor-pointer bt-font-medium bt-text-gray-3"
            activeIndex={0}
          >
            <TabViewPanel header="Display">
              <DisplayFilterTab ref={displayFilterTabRef} />
            </TabViewPanel>
          </TabView>
        </div>
        <Button data-cy="filter-overlay-apply-button" onClick={handleSave}>
          Apply
        </Button>
      </OverlayPanel>
    </>
  );
}

export default memo(FilterOverlay);
